import BadgeBase from "../BadgeBase";

const campaignTypeConfig = {
  single: { label: "Única", tone: "info" },
  unique: { label: "Única", tone: "info" },
  immediate: { label: "Única", tone: "info" },
  recurring: { label: "Régua", tone: "warning" },
  ruler: { label: "Régua", tone: "warning" },
  polling: { label: "Monitoramento", tone: "success" },
  monitoring: { label: "Monitoramento", tone: "success" },
};

export default function CampaignTypeBadge({ value, size = "md", sx }) {
  const normalizedValue = String(value || "").trim().toLowerCase();
  const config = campaignTypeConfig[normalizedValue] || {
    label: value || "Tipo",
    tone: "neutral",
  };

  return (
    <BadgeBase tone={config.tone} size={size} sx={sx}>
      {config.label}
    </BadgeBase>
  );
}
